export default __webpack_public_path__ + "assets/images/1e7cbdde7d91cd2037e737407ff2a9bf.jpg";